import { gql } from 'apollo-angular';
import { Activity } from '../../entities/activity/activity';
import { Page } from '../../entities/page/page';

export const ACTIVITIES_QUERY = gql`
query getActivitiesPaged($filter: ActivityFilter)
{
  activities: getActivitiesPaged(filter: $filter)
  {
    totalPages
    totalElements
    number
    size
    content {
        id
        activityType
        createdDateTime
        viewModel
        actor {
          id
          displayName
          actorType
        }
        owner{
          id
          ownerType
          label
        }
    }
  }
}
`;

export interface ActivitiesQueryResponse {
  activities: Page<Activity>;
  loading: boolean;
}
